/// <reference path="../../types/signalr.d.ts" />

namespace SP {
	export class CheckboxDoodle {
		_checked: boolean = null;
		checkbox: HTMLInputElement;
		track = document.createElement("div");
		handle = document.createElement("div");
		onChange: () => void = null;

		private binder: (e: PointerEvent) => void;

		constructor(checkbox: HTMLInputElement) {
			this.checkbox = checkbox;
			this.checkbox.style.display = "none";
			this.checked = checkbox.checked;
			this.track.classList.add("sp_checkbox_doodle", "value");
			this.track.appendChild(this.handle);
			this.checkbox.parentElement.insertBefore(this.track, this.checkbox);
			this.binder = this.pointerdown.bind(this);
			this.setEvent(!this.checkbox.disabled && !this.checkbox.readOnly);
		}

		private setEvent(activate: boolean) {
			console.log("setEvent", activate);
			if (activate) this.track.addEventListener("pointerdown", this.binder);
			else this.track.removeEventListener("pointerdown", this.binder);
		}

		pointerdown(e: PointerEvent) {
			console.log("pointerdown", e, this);
			this.checked = !this.checked;

			if (this.onChange != null)
				this.onChange();
		}

		get disabled(): boolean {
			return this.checkbox.disabled;
		}

		set disabled(val: boolean) {
			if (val != this.checkbox.disabled) {
				this.checkbox.disabled = val;
				this.setEvent(val);
			}
		}

		get checked(): boolean {
			return this._checked;
		}

		set checked(val: boolean) {
			if (val != this._checked) {
				this.checkbox.checked = val;
				this._checked = val;
				if (val) this.track.classList.add("checked");
				else this.track.classList.remove("checked");

		
			}
		}
	}
}